var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoupon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "#8391a2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32869",
    "data-name": "Rectangle 32869",
    width: 16,
    height: 16,
    transform: "translate(26 433)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48462",
    "data-name": "Path 48462",
    d: "M0-16H16V0H0Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_914",
    "data-name": "Mask Group 914",
    transform: "translate(-26 -433)",
    clipPath: "url(#clipPath)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-8_22_",
    "data-name": "svgexport-8 (22)",
    transform: "translate(26 433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_90017",
    "data-name": "Group 90017",
    transform: "translate(0 16)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48458",
    "data-name": "Path 48458",
    d: "M0,0C0-.234-.2-.458-.52-.665A1.787,1.787,0,0,1-1.126-2.93a.873.873,0,0,0,.09-.82.873.873,0,0,0-.755-.332A1.786,1.786,0,0,1-3.45-5.74.873.873,0,0,0-3.781-6.5a.873.873,0,0,0-.82.09,1.787,1.787,0,0,1-2.265-.607c-.206-.315-.431-.519-.665-.519s-.458.2-.665.519a1.787,1.787,0,0,1-2.265.607.873.873,0,0,0-.82-.09.873.873,0,0,0-.332.755,1.786,1.786,0,0,1-1.658,1.658.873.873,0,0,0-.755.332.873.873,0,0,0,.09.82,1.787,1.787,0,0,1-.607,2.265c-.315.207-.52.431-.52.665s.2.458.52.665a1.787,1.787,0,0,1,.607,2.265.873.873,0,0,0-.09.82.873.873,0,0,0,.755.332A1.787,1.787,0,0,1-11.613,5.74a.872.872,0,0,0,.332.755.872.872,0,0,0,.82-.09A1.787,1.787,0,0,1-8.2,7.012c.207.315.431.52.665.52s.458-.2.665-.52A1.787,1.787,0,0,1-4.6,6.4a.872.872,0,0,0,.82.09A.872.872,0,0,0-3.45,5.74,1.787,1.787,0,0,1-1.791,4.082a.873.873,0,0,0,.755-.332.873.873,0,0,0-.09-.82A1.787,1.787,0,0,1-.52.665C-.2.458,0,.234,0,0Z",
    transform: "translate(15.531 -8)",
    strokeWidth: 0.938
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48459",
    "data-name": "Path 48459",
    d: "M0,0A.938.938,0,0,1-.937.938.938.938,0,0,1-1.875,0,.938.938,0,0,1-.937-.937.938.938,0,0,1,0,0Z",
    transform: "translate(7.063 -10.813)",
    strokeWidth: 0.938
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48460",
    "data-name": "Path 48460",
    d: "M0,0A.938.938,0,0,1-.937.938.938.938,0,0,1-1.875,0,.938.938,0,0,1-.937-.937.938.938,0,0,1,0,0Z",
    transform: "translate(10.813 -5.188)",
    strokeWidth: 0.938
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48461",
    "data-name": "Path 48461",
    d: "M0,0-5.625,7.5",
    transform: "translate(10.813 -11.75)",
    strokeWidth: 0.938
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupon);
export default __webpack_public_path__ + "static/media/coupon.19863b967e77de0649cea371fb4b308e.svg";
export { ForwardRef as ReactComponent };